import * as Sentry from "@sentry/vue";
import type { App } from "vue";
import type { Router } from "vue-router";

function sampleRate(): number {
  const value = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0.1");
  return Number.isFinite(value) ? Math.min(Math.max(value, 0), 1) : 0.1;
}

function tracePropagationTargets(): Array<string | RegExp> {
  const targets: Array<string | RegExp> = [/^\//];
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

  if (apiBaseUrl) {
    try {
      targets.push(new URL(apiBaseUrl).origin);
    } catch {
      // A relative API URL is already covered by the same-origin pattern.
    }
  }

  return targets;
}

export function initializeSentry(app: App, router: Router): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();
  if (!dsn) return;

  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: sampleRate(),
    tracePropagationTargets: tracePropagationTargets(),
    sendDefaultPii: false,
  });
}
